import PageHeader from "../components/layout/PageHeader";
import { TID } from "../lib/testIds";
import { useEffect, useState } from "react";
import { api, apiErrorMessage } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function KraiApiPage() {
  const [settings, setSettings] = useState(null);
  const [form, setForm] = useState({ krai_api_base_url: "", krai_api_token: "" });
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  async function load() {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
      setForm({ krai_api_base_url: data.krai_api_base_url || "", krai_api_token: "" });
    } catch (e) { toast.error(apiErrorMessage(e)); }
  }
  async function save(e) {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        n8n_base_url: settings?.n8n_base_url || "",
        n8n_api_key: "",
        n8n_webhook_url: settings?.n8n_webhook_url || "",
        krai_api_base_url: form.krai_api_base_url,
        krai_api_token: form.krai_api_token,
      };
      const { data } = await api.put("/settings", payload);
      setSettings(data);
      setForm((f) => ({ ...f, krai_api_token: "" }));
      toast.success("Configuración KRAI API guardada");
    } catch (e) { toast.error(apiErrorMessage(e)); }
    finally { setSaving(false); }
  }

  return (
    <div data-testid={TID.kraiApi.root}>
      <PageHeader
        eyebrow="Backend externo"
        title="KRAI API"
        description="Configura la conexión con tu KRAI API existente en Hostinger (Docker + Traefik). La infraestructura actual NO se modifica."
      />
      <form
        onSubmit={save}
        className="rounded-md border border-zinc-800 bg-zinc-950 p-6 space-y-5 max-w-2xl"
      >
        <div className="space-y-2">
          <Label className="text-zinc-300">Base URL</Label>
          <Input
            value={form.krai_api_base_url}
            onChange={(e) => setForm({ ...form, krai_api_base_url: e.target.value })}
            placeholder="https://api.krai.tu-dominio.com"
            className="bg-zinc-900 border-zinc-800 font-mono text-sm"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-zinc-300">
            Token
            {settings?.krai_api_token_set && (
              <span className="ml-2 text-[11px] font-mono text-emerald-400">
                guardado: {settings.krai_api_token_masked}
              </span>
            )}
          </Label>
          <Input
            type="password"
            value={form.krai_api_token}
            onChange={(e) => setForm({ ...form, krai_api_token: e.target.value })}
            placeholder={settings?.krai_api_token_set ? "Dejar vacío para conservar" : "krai_..."}
            className="bg-zinc-900 border-zinc-800 font-mono text-sm"
          />
        </div>
        <div className="pt-2 flex justify-end">
          <Button
            type="submit"
            disabled={saving}
            className="bg-white text-black hover:bg-zinc-200"
          >
            {saving ? "Guardando…" : "Guardar"}
          </Button>
        </div>
      </form>
    </div>
  );
}
